import {ModalPortalGuestHandler} from 'types'

let handler: ModalPortalGuestHandler | undefined

export function setModalPortalGuestHandler(instance: ModalPortalGuestHandler) {
  handler = instance
}

export function showModalPortalGuest() {
  handler && handler.showModalPortalGuest()
}
